import { Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface IOwnProps {
  children: ReactNode;
}

const HeaderSectionMobilePage: React.FC<IOwnProps> = ({ children }) => {
  return (
    <Text
      bgColor="primaryColor"
      color="white"
      boxSizing="border-box"
      py={1}
      mb={0}
      px={5}
      fontWeight="bold"
      fontSize="small"
      textAlign="center"
      h="fit-content"
      w="full"
      textTransform="uppercase"
    >
      {children || '--'}
    </Text>
  );
};

export default HeaderSectionMobilePage;
